import { useMutation } from 'react-query';
import http from '../http';
import { AxiosResponse } from 'axios';

const endpoint = 'v1/invoices/send_email';

type SendInvoicesToEmailPayload = {
  finance_account_id: number;
  year: number;
  month: number;
  invoice_types: string;
};

type SendInvoicesToEmailResponse = AxiosResponse<{
  message: string;
}>;

export const postInvoicesToEmail = (payload: SendInvoicesToEmailPayload) =>
  http.post<SendInvoicesToEmailPayload, SendInvoicesToEmailResponse>(
    endpoint,
    payload,
  );

export const usePostInvoicesToEmail = () => useMutation(postInvoicesToEmail);
